import moment from "moment-timezone";

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "react-bootstrap";

import { SalesService } from "shared/services";
import { Loader } from "shared/hoc/loader/Loader";
import { ADSENSE } from "shared/settings/config";
import { Adsense } from "shared/utils/Adsense";

import SaleCard from "./SaleCard";
import { PaginationDots, Pagination } from "./Pagination";

import './ListHoc.scss';
import { useDispatch } from "react-redux";

export const SALE_LIST_TYPE = {
    ESTATESALE: 'estate-sale',
    FEATUREDSALE: 'featured-sale',
    ESTATESALEFORLOCATION: 'estate-sale-for-location'
};

const SCREEN_CONFIG = [
    { min: 2001, max: Infinity, count: 4 },
    { min: 1201, max: 2000, count: 3 },
    { min: 769, max: 1200, count: 2 },
    { min: 0, max: 768, count: 1 }
];

export const SaleListHoc = ({ props, search, showAd, isHorizontal=false, type=SALE_LIST_TYPE.ESTATESALE, locationDetail=null }) => {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const [pageLoading, setPageLoading] = useState(false);
    const [listResponse, setListResponse] = useState({});
    const [dotsResponsiveSize, setDotsResponsiveSize] = useState(0);
    const [isNearbySale, setIsNearBySale] = useState(false);
    const currentindex = useRef(1)
    const totalrecord = useRef(0)

    const scrollRef = useRef(null);

    useEffect(() => {
        if(!isHorizontal && statemaintenance?.["Estate-Sale-List"] ) {
            let data = statemaintenance?.["Estate-Sale-List"]
            totalrecord.current = data?.total
            getListData(data?.["pagekey"], data?.currentPage)
        } else {
            getListData();
        }
    }, [search, locationDetail]);
    
    useEffect(() => {
        if ( Array.isArray(listResponse.data) ) {
            const scrollContainer = document.querySelector('.scroll-content');
            if (scrollContainer) {
                let key = type === SALE_LIST_TYPE.ESTATESALE ? 'Estate-Sale-List' : 'Estate-Sale-List-For-Location';
                if(statemaintenance?.[key]?.scrollindex) {
                    setTimeout(() => {
                        scrollContainer.scrollTop = statemaintenance?.[key]?.scrollindex;
                        let pusttoStore = { ...statemaintenance };
                        pusttoStore[key] = {
                            ...pusttoStore?.[key],
                            scrollindex: null
                        }
                        dispatch({
                            type: 'PUSH_TO_STATE', payload: pusttoStore
                        });
                        // scrollContainer.scrollTo({ top: statemaintenance?.["Estate-Sale-List"]?.scrollindex, left: 0, behavior: 'smooth' });
                    }, 100);
                } else {
                    scrollContainer.scrollTop = 0;
                }
            } else {
                window.scrollTo(0, 0);
            }
        }
    }, [listResponse])
    

    useEffect(() => {
        if ( isHorizontal && window.innerWidth ) {
            const screenConfig = SCREEN_CONFIG.find(config => window.innerWidth >= config.min && window.innerWidth <= config.max);

            if ( screenConfig.count != dotsResponsiveSize ) {
                document.documentElement.style.setProperty('--sale-card-per-page', screenConfig.count);
                setDotsResponsiveSize(screenConfig.count);
            }
        }
    }, [window.innerWidth]);

    const getListData = (page=null,currentPageNumber=1,previousPageNumber=0,total=totalrecord.current) => {
        if(!isHorizontal) {
            currentindex.current = currentPageNumber
            let pusttoStore = { ...statemaintenance }
            pusttoStore["Estate-Sale-List"] = {
                ...pusttoStore?.["Estate-Sale-List"],
                pagekey: page,
                currentPage: currentPageNumber,
                previousPage:previousPageNumber,
                total: total || totalrecord.current
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
        if ( type === SALE_LIST_TYPE.ESTATESALE ) {
            getEstateSaleList(page);
        } else if ( type === SALE_LIST_TYPE.FEATUREDSALE ) {
            getFeatureSaleList();
        } else if ( locationDetail.id && type === SALE_LIST_TYPE.ESTATESALEFORLOCATION ) {
            setPageLoading(true);
            getSaleListForLocation(isNearbySale, page);
        }
    };

    const getEstateSaleList = (page=null) => {
        const payload = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "url", "itemimageurl", "staticcoverimage", "staticinsertimage", "saleitemreceiptmethod", "locationstatecode", "locationcode"],
            "filter": [
                { "field": "itemcount", "value": 1, "op": ">=", "join": "AND" },
                { "field": "status", "value": "Started", "op": "=", "join": "AND" },
            ],
            "page": { 'size': 24 }
        };

        if ( search ) {
            if ( Array.isArray(search.filter) ) {
                payload.filter = [...payload.filter, ...search.filter]; 
            }
        }
        
        if ( page ) {
            payload.page = {...payload.page, ...page};
        }
        
        setPageLoading(true);
        SalesService.getSalesList(payload).then(response => {
            if(response?.data?.page?.total) {
                totalrecord.current = response?.data?.page?.total
            }
            setListResponse(response.data);
            setPageLoading(false);
        }).catch((error) => {
            setPageLoading(false);
        });
    };

    const getFeatureSaleList = (endbefore = 24) => {
        const now = moment.utc();
        const end = now.add(endbefore, 'hours').format("YYYY-MM-DD HH:mm:ss");
        const payload = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "staticcoverimage", "staticinsertimage", "saleitemreceiptmethod"],
            "filter": [
                { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" },
                { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
            ]
        };

        SalesService.getSalesList(payload).then(response => {
            if ( response.data.data.length > 0 ) {
                setListResponse(response.data);
            } else if ( endbefore != 48 ) {
                getFeatureSaleList(48);
            }
        }).catch((error) => {

        });
    };

    const getSaleListForLocation = (getNearby48HoursSale=false, page) => {
        const payload = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc", "itemimageurl", "url", "staticcoverimage", "staticinsertimage", "saleitemreceiptmethod"],
            "filter": [
                { "field": "status", "value": "Started", "op": "=", "join": "AND" }
            ],
            "page": { "size": 4 }
        };

        if ( page ) {
            payload.page = {...payload.page, ...page};
        }
        
        if ( getNearby48HoursSale ) {
            const end = moment.utc().add(48, 'hours').format("YYYY-MM-DD HH:mm:ss");
            payload.filter.push({ "field": "zipcode", "value": locationDetail.zip, "op": "=", "join": "AND" });
            payload.filter.push({ "field": "miles", "value": "100", "op": "=", "join": "AND" });
            payload.filter.push({ "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" });
            payload.filter.push({ "field": "isdeleted", "value": 0, "op": "=", "join": "AND" });
        } else {
            payload.filter.push({ "field": "locationid", "value": locationDetail.id, "op": "=", "join": "AND" });
        }
        SalesService.getSalesList(payload).then(response => {
            if ( response.data.data.length > 0 ) {
                setListResponse(response.data);
                setPageLoading(false);
            } else if ( !getNearby48HoursSale ) {
                getSaleListForLocation(true);
                setIsNearBySale(true);
            } else {
                setListResponse({ data: [] });
                setPageLoading(false);
            }
        }).catch((error) => {
            setPageLoading(false);
        });
    };

    return (
        <div className={`sale-list-container ${type}`}>
            {
                pageLoading ?
                    <Loader /> :
                    <>
                        {
                            type === SALE_LIST_TYPE.FEATUREDSALE ? 
                            <div className="featured-sale-header">
                                <div className="heading">Today's Featured Estate Sales</div>
                                <div role="button" className="link" onClick={() => {
                                    props.history.push('/estate-sale/list');
                                }}>Explore All</div>
                            </div> : null
                        }
                        {
                            type === SALE_LIST_TYPE.ESTATESALEFORLOCATION ? 
                            <div className="location-sale-header">
                                <div className="heading">Estate Sales at {locationDetail.title}</div>
                                <div className="sub-heading">{locationDetail.description}</div>

                                {
                                    isNearbySale ? 
                                    <>
                                        <div className="nearby-header">
                                            <div>This location is currently crafting a new and unique collection.</div>
                                            <div>Check back for updates!</div>
                                        </div>
                                        {
                                            Array.isArray(listResponse.data) ? 
                                            ( 
                                                listResponse?.data?.length > 0 ? 
                                                <div className="nearby-found">Find a sale closest to you. You're guaranteed to find something you love!</div> : 
                                                <div className="nearby-not-found">
                                                    <div>Looking for something specific?</div>
                                                    <Button className="btn btn-secondary mt-2" onClick={() => props.history.push('/explore')}>Search</Button>
                                                </div>
                                            ) : null
                                        }
                                    </> : null
                                }
                            </div> : null
                        }
                        {
                            Array.isArray(listResponse.data) && listResponse.data.length > 0 ?
                                <Row className={isHorizontal ? 'horizontal-row' : 'vertical-row'} xs={1} sm={1} md={type === SALE_LIST_TYPE.ESTATESALEFORLOCATION ? 1 : 2} lg={2} xl={2} ref={scrollRef}>
                                    {
                                        listResponse.data.map((sale, index) => (
                                            <Col key={"sale-list-" + sale.id} className={isHorizontal ? 'horizontal-col' : 'vertical-col'} >
                                                <SaleCard sale={sale} navigate={(sale) => {
                                                    const scrollContainer = document.querySelector('.scroll-content');
                                                    let pusttoStore = { ...statemaintenance }
                                                    if(locationDetail){
                                                        pusttoStore["Estate-Sale-List-For-Location"] = {
                                                            ...pusttoStore?.["Estate-Sale-List-For-Location"],
                                                            scrollindex:scrollContainer.scrollTop
                                                        }
                                                    
                                                    }else{
                                                        pusttoStore["Estate-Sale-List"] = {
                                                            ...pusttoStore?.["Estate-Sale-List"],
                                                            scrollindex:scrollContainer.scrollTop
                                                        }
                                                    }
                                                    dispatch({
                                                        type: 'PUSH_TO_STATE', payload: pusttoStore
                                                    });
                                                    props.history.push({ pathname: `/estate-sale/${sale.id}`, state: { saleTitle: sale.title } })
                                                }} saleBoard={type === SALE_LIST_TYPE.ESTATESALE ? false : true} props={props} />
                                            </Col>
                                        ))
                                    }
                                </Row> : null
                        }
                        
                        {
                            Array.isArray(listResponse.data) && listResponse.data.length == 0 ?
                            (
                                <>
                                    {
                                        type === SALE_LIST_TYPE.ESTATESALE ? 
                                        <div className="estate-sale-no-data">
                                            <div className="heading">No estate sales found</div>
                                            <div className="sub-heading">Please adjust your search criteria and try again.</div>
                                        </div> : null
                                    }

                                    {
                                        type === SALE_LIST_TYPE.FEATUREDSALE ? 
                                        <div className="featured-sale-no-data">
                                            <div className="heading">No sale available</div>
                                        </div> : null
                                    }
                                </>
                            ) : null
                        }
                    </>
            }

            {
                isHorizontal ? 
                <PaginationDots scrollRef={scrollRef} loading={pageLoading} totalSize={listResponse?.data?.length} pageSize={dotsResponsiveSize} /> : 
                <Pagination loading={pageLoading} page={listResponse.page} onPageChangeCallback={(page,currentPageNumber,previousPageNumber,total) => getListData(page,currentPageNumber,previousPageNumber,total) } pageData={{
                    currentindex:currentindex.current,
                    total:totalrecord?.current
                }}/>
            }
            { showAd && ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : "" }
        </div>
    )
};